import axiosInstance from '../config/axiosInstance';
import { ENDPOINTS } from '../config/apiConfig';

export const pingUser = async () => {
    try {
        const response = await axiosInstance.post(ENDPOINTS.userProfile);
        return response.data;  // Assuming the API returns JSON data
    } catch (error) {
        console.error("Error in Creating / Updating User Profile", error);
        throw error;  // Propagate the error for handling in the component
    }
};


  